export default {
  SettingBaseDataAfterSalesReason: {
    header: {
      code: 'Reason Code',
      description: 'Reason Description',
      isUse: 'Whether it has been used',
    },
    newAfterSales: 'Add after-sales reason',
    confirmText: 'After-sales reason',
    msgWarning: 'You have selected data that has been used and cannot be deleted',

    table: {
      code: 'Reason Code',
      description: 'Reason Description',
      isUse: 'Whether it has been used',
      descriptionText: 'Please enter reason description',
      newAfterSales: 'Add after-sales reasons',
      editAfterSales: 'Edit after-sales reason',
      salesChannels: 'Sales Channels',
      generated: 'Automatically generated',
    }
  }
};
